<template>
    <b-modal ref="my-modal" okTitle="発行" ok-only @ok="emitPrintEvent">
        <label for="jan">商品コード</label>
        <b-form-input id="jan" v-model="item_cd" disabled />

        <label for="item_name">商品名</label>
        <b-form-input id="item_name" v-model="item_name" disabled />

        <label for="count">枚数</label>
        <b-form-input id="count" type="number" v-model="count" disabled />
        <keypad
            class="suryo-keypad"
            ref="keypad"
            v-on:change="countChanged($event)"
        />
    </b-modal>
</template>

<style scoped>
</style>

<script>
import Keypad from '@/components/views/Keypad.vue'

export default {
    name: 'TanpinNebikiPrintModal',
    components: {
        Keypad,
    },
    props: [],
    data() {
        return {
            item_cd: "",
            item_name: "",
            count: null,
        }
    },
    computed: {
        nebiki_percentage() {
            return `${this.nebiki_rate * 100} %`
        },
    },
    methods: {
        open(item_info) {
            console.log(item_info)

            this.reset()
            this.item_cd = item_info.item_cd
            this.item_name = item_info.item_name
            this.count = item_info.count
            this.showModal()
        },
        isOpen() {
            return this.$refs['my-modal'].isVisible
        },
        reset() {
            this.item_cd = ""
            this.item_name = ""
            this.count = null
        },
        showModal() {
            this.$refs['my-modal'].show()
        },
        hideModal() {
            this.$refs['my-modal'].hide()
        },
        countChanged(event) {
            this.count = event.value
        },
        emitPrintEvent() {
            console.log(this)
            this.$emit('publish', {
                item_cd: this.item_cd,
                std_price: this.std_price,
                nebiki_rate: this.nebiki_rate,
                price: this.price,
                count: this.count,
            })
        },
    },
}
</script>
